export { Quote as default } from './Quote';
